var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21.5781V20.1719C20.25 17.842 18.0911 15.9531 15.4282 15.9531H11.5718C8.90888 15.9531 6.75 17.842 6.75 20.1719V21.5781M16.875 9.20312C16.875 10.0982 16.5194 10.9567 15.8865 11.5896C15.2536 12.2225 14.3951 12.5781 13.5 12.5781C12.6049 12.5781 11.7464 12.2225 11.1135 11.5896C10.4806 10.9567 10.125 10.0982 10.125 9.20312C10.125 8.30802 10.4806 7.44957 11.1135 6.81664C11.7464 6.1837 12.6049 5.82813 13.5 5.82812C14.3951 5.82812 15.2536 6.1837 15.8865 6.81664C16.5194 7.44957 16.875 8.30802 16.875 9.20312Z",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6582f95e1b8767c5ab4470851ec5e096.svg";
export { ForwardRef as ReactComponent };